import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Notifications = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'itinerary',
      icon: '📋',
      title: 'Trip Starting Tomorrow',
      message: 'Your 3-day Montreal adventure begins at 9:00 AM. Meeting point: Old Port.',
      time: '2 min ago',
      unread: true,
      category: 'travel'
    },
    {
      id: 2,
      type: 'booking',
      icon: '✅',
      title: 'Booking Confirmed',
      message: 'Notre-Dame Basilica tour confirmed for Oct 28, 2:00 PM. E-ticket sent to your email.',
      time: '1h ago',
      unread: true,
      category: 'booking'
    },
    {
      id: 3,
      type: 'community',
      icon: '💬',
      title: 'New Reply',
      message: 'Sarah replied to your comment in "Best Bagels in Mile End" discussion.',
      time: '3h ago',
      unread: true,
      category: 'social'
    },
    {
      id: 4,
      type: 'weather',
      icon: '🌨️',
      title: 'Weather Alert',
      message: 'Snow expected tomorrow morning. Roads may be slippery. Plan extra travel time.',
      time: '5h ago',
      unread: false,
      category: 'alert'
    },
    {
      id: 5,
      type: 'reward',
      icon: '🏆',
      title: 'Achievement Unlocked',
      message: 'You earned "Plateau Explorer" badge and 200 points for visiting 5 locations!',
      time: '1d ago',
      unread: false,
      category: 'reward'
    },
    {
      id: 6,
      type: 'restaurant',
      icon: '🍽️',
      title: 'Table Reserved',
      message: 'Your reservation at Schwartz\'s Deli for 2 people is confirmed for tomorrow, 7:30 PM.',
      time: '1d ago',
      unread: false,
      category: 'booking'
    },
    {
      id: 7,
      type: 'transport',
      icon: '🚇',
      title: 'Metro Service Update',
      message: 'Orange Line running with delays due to maintenance. Consider alternate routes.',
      time: '2d ago',
      unread: false,
      category: 'alert'
    },
    {
      id: 8,
      type: 'event',
      icon: '🎪',
      title: 'Event Reminder',
      message: 'Montreal Jazz Festival starts this weekend. Don\'t miss the opening concert!',
      time: '2d ago',
      unread: false,
      category: 'travel'
    },
    {
      id: 9,
      type: 'hotel',
      icon: '🏨',
      title: 'Check-in Available',
      message: 'Early check-in approved at Hotel Nelligan. Room ready from 1:00 PM.',
      time: '3d ago',
      unread: false,
      category: 'booking'
    },
    {
      id: 10,
      type: 'tip',
      icon: '💡',
      title: 'Local Tip',
      message: 'Jean-Talon Market is less crowded on weekday mornings. Perfect for photos!',
      time: '3d ago',
      unread: false,
      category: 'travel'
    }
  ]);

  const filters = [
    { id: 'all', label: 'All', count: notifications.length },
    { id: 'unread', label: 'Unread', count: notifications.filter(n => n.unread).length },
    { id: 'travel', label: 'Travel', count: notifications.filter(n => n.category === 'travel').length },
    { id: 'booking', label: 'Bookings', count: notifications.filter(n => n.category === 'booking').length },
    { id: 'social', label: 'Social', count: notifications.filter(n => n.category === 'social').length }
  ];

  const filteredNotifications = notifications.filter(n => {
    if (activeFilter === 'all') return true;
    if (activeFilter === 'unread') return n.unread;
    return n.category === activeFilter;
  });

  const markAsRead = (id) => {
    setNotifications(notifications.map(n => 
      n.id === id ? { ...n, unread: false } : n
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({ ...n, unread: false })));
  };

  const deleteNotification = (id) => {
    setNotifications(notifications.filter(n => n.id !== id));
  };

  const clearAll = () => {
    setNotifications([]);
  };

  // Inline styles
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: '#f9fafb'
    },
    header: {
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #e5e7eb'
    },
    headerTop: {
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    backButton: {
      padding: '4px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    headerTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#111827',
      margin: 0
    },
    headerActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    actionButton: {
      padding: '8px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#3b82f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    filterContainer: {
      padding: '0 16px 8px',
      display: 'flex',
      gap: '12px',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    },
    filterButton: (isActive) => ({
      padding: '6px 12px',
      borderRadius: '20px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      transition: 'all 0.2s',
      backgroundColor: isActive ? '#3b82f6' : '#f3f4f6',
      color: isActive ? '#ffffff' : '#4b5563'
    }),
    notificationsList: {
      flex: 1,
      overflowY: 'auto',
      padding: '16px'
    },
    notificationCard: (isUnread) => ({
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      marginBottom: '12px',
      overflow: 'hidden',
      borderLeft: isUnread ? '4px solid #3b82f6' : 'none',
      cursor: 'pointer'
    }),
    notificationContent: {
      padding: '16px'
    },
    notificationMain: {
      display: 'flex',
      gap: '12px'
    },
    iconBox: {
      width: '40px',
      height: '40px',
      background: 'linear-gradient(135deg, #eff6ff 0%, #faf5ff 100%)',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      flexShrink: 0
    },
    notificationBody: {
      flex: 1,
      minWidth: 0
    },
    notificationHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '8px'
    },
    notificationTitle: (isUnread) => ({
      fontSize: '14px',
      fontWeight: '600',
      color: isUnread ? '#111827' : '#4b5563',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }),
    unreadDot: {
      width: '8px',
      height: '8px',
      backgroundColor: '#3b82f6',
      borderRadius: '50%',
      display: 'inline-block'
    },
    deleteButton: {
      padding: '4px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#9ca3af'
    },
    notificationMessage: (isUnread) => ({
      fontSize: '14px',
      color: isUnread ? '#4b5563' : '#6b7280',
      marginTop: '4px',
      lineHeight: '1.4'
    }),
    notificationFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '8px'
    },
    timeText: {
      fontSize: '12px',
      color: '#9ca3af'
    },
    markReadButton: {
      fontSize: '12px',
      color: '#3b82f6',
      fontWeight: '500',
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    },
    emptyState: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '32px'
    },
    emptyIcon: {
      width: '80px',
      height: '80px',
      backgroundColor: '#f3f4f6',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '16px',
      fontSize: '32px'
    },
    emptyTitle: {
      fontSize: '18px',
      fontWeight: '500',
      color: '#111827',
      marginBottom: '4px'
    },
    emptyText: {
      fontSize: '14px',
      color: '#6b7280',
      textAlign: 'center'
    },
    summaryBar: {
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e5e7eb',
      padding: '12px 16px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#6b7280'
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerTop}>
          <div style={styles.headerLeft}>
            <button 
              style={styles.backButton}
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left" style={{ fontSize: '24px', color: '#4b5563' }}></i>
            </button>
            <h1 style={styles.headerTitle}>Notifications</h1>
          </div>
          <div style={styles.headerActions}>
            <button 
              style={styles.actionButton}
              onClick={markAllAsRead}
              title="Mark all as read"
            >
              <i className="bi bi-check-all" style={{ fontSize: '20px' }}></i>
            </button>
            <button 
              style={{ ...styles.actionButton, color: '#6b7280' }}
              onClick={clearAll}
              title="Clear all"
            >
              <i className="bi bi-trash3" style={{ fontSize: '20px' }}></i>
            </button>
          </div>
        </div>

        {/* Filter Tabs */}
        <div style={styles.filterContainer}>
          {filters.map(filter => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              style={styles.filterButton(activeFilter === filter.id)}
            >
              {filter.label}
              {filter.count > 0 && ` (${filter.count})`}
            </button>
          ))}
        </div>
      </div>

      {/* Notifications List */}
      {filteredNotifications.length > 0 ? (
        <div style={styles.notificationsList}>
          {filteredNotifications.map((notification) => (
            <div
              key={notification.id}
              style={styles.notificationCard(notification.unread)}
              onClick={() => markAsRead(notification.id)}
            >
              <div style={styles.notificationContent}>
                <div style={styles.notificationMain}>
                  <div style={styles.iconBox}>
                    {notification.icon}
                  </div>
                  <div style={styles.notificationBody}>
                    <div style={styles.notificationHeader}>
                      <div style={styles.notificationTitle(notification.unread)}>
                        {notification.title}
                        {notification.unread && <span style={styles.unreadDot}></span>}
                      </div>
                      <button
                        style={styles.deleteButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteNotification(notification.id);
                        }}
                      >
                        <i className="bi bi-x-lg" style={{ fontSize: '16px' }}></i>
                      </button>
                    </div>
                    <p style={styles.notificationMessage(notification.unread)}>
                      {notification.message}
                    </p>
                    <div style={styles.notificationFooter}>
                      <span style={styles.timeText}>{notification.time}</span>
                      {notification.unread && (
                        <button
                          style={styles.markReadButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            markAsRead(notification.id);
                          }}
                        >
                          Mark as read
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>
            🔔
          </div>
          <h3 style={styles.emptyTitle}>No notifications</h3>
          <p style={styles.emptyText}>
            {activeFilter === 'all' 
              ? "You're all caught up! Check back later for updates."
              : `No ${activeFilter} notifications to show.`}
          </p>
        </div>
      )}

      {/* Summary Bar */}
      {notifications.length > 0 && (
        <div style={styles.summaryBar}>
          {notifications.filter(n => n.unread).length > 0 
            ? `${notifications.filter(n => n.unread).length} unread notification${notifications.filter(n => n.unread).length > 1 ? 's' : ''}`
            : 'All notifications read'}
        </div>
      )}
    </div>
  );
};

export default Notifications;